
import { throwError as observableThrowError, Observable, BehaviorSubject } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';




import { API } from '../../core/app-config';
import { ResponseMessage, PagerList,ContractType, FPResponse } from '../.././shared/shared.model';
import { SharedService } from '../.././shared/shared.service';
import {
    ApprovalQueue, ApprovalQueueList, AdvancedSearchDropdown, ConfigValues, PricingFormModel,
    SJobAndBillingDetails, ServiceNotesAndTechNotes, NotesModel, PricingModel, WorkRequestSaveModel,
    WorkTypeDd, WorkRequestDd, WoJobvendorCost, VendorPaymentHistory, JobvendorCost, PaymentDetail,
    EquipmentListModel, EquipmentEntity, ExistingEquipmentModel, AttachmentModel, ChecklistModel,
    ChecklistDropdown, DynamicModel, DynamicCheckListDetails, DynamicSaveModel, ApprovalJobModel, Pricing,
    RevertApprovalHistory, Download, BrandList, ModelList, CustomerTimeZone, JobStatusReason,
    TechnicianJobStatusUpdate, TaxGroup, PartPricing, SystemSettings, Reject, Region, paymentApproval, EquipmentCFModel, WorkRequestCFModel, RefStatusReasonEntity,
    PunchPointApprovalQueue,PunchPointApprovalQueueList, PunchPointApproveRejectList, PunchDetails, PartDetail
} from './approval-queue.model';
import { PrintcheckListModel, PrintCheckListOutput, Logo, DownloadFile, FileDetails } from '../../technician/technician-jobs/technician-jobs.models';
import { CustomFieldsConfiguration } from '../../shared/custom-fields/custom-fields-models';
import { PartRequest } from 'app/layout/work-order/work-order-models';

@Injectable()

export class ApprovalQueueService {
    constructor(private _http: Http) { }

    private payment = new BehaviorSubject<paymentApproval>(null);
    PaymentDetails = this.payment.asObservable();
    /*************************** Approval Queue List **********************************/

    // APPROVALQUEUE

    GetApprovalQueueList(model: ApprovalQueue, MaxRoleGroupId: number, LoginId: number, LoginVendorId: number, sortBy: string, orderBy: string, startRecord: number,
        endRecord: number): Observable<ApprovalQueueList> {
        return this._http.post(API.APPROVALQUEUE + "/GetApprovalQueueList/" + MaxRoleGroupId + "/" + LoginId + "/" + LoginVendorId + "/" + sortBy + "/" + orderBy + "/" + startRecord + "/" + endRecord, model).pipe(
            map(this.extractData));
    }

    getAdvansedSearch(companyId: number, loginId: number): Observable<AdvancedSearchDropdown> {
        return this._http.get(API.COMMON + '/GetAdvansedSearch/' + companyId + "/" + loginId).pipe(
            map(res => res.json()));
    }

    getAllConfigValues(companyId: number): Observable<ConfigValues[]> {
        return this._http.get(API.CONFIGMASTER + "/GetConfigValueAll" + "?CompanyID=" + companyId).pipe(
            map(this.extractData));
    }

    /*************************** End Approval Queue List **********************************/

    /**Left Panel */
    getCustomerAddress(companyId: number, wojobid: number, workOrderId: number, addressId: number): Observable<SJobAndBillingDetails> {
        return this._http.get(API.APPROVALQUEUE + '/GetJobAndBillingDetaisls/' + companyId + "/" + wojobid + "/" + workOrderId + "/" + addressId).pipe(
            map(this.extractData));
    }

    /*************************** Summary View **********************************/

    /**Get Job Details and Billing Details */
    getJobAndBillingDetails(companyId: number, wojobid: number, workOrderId: number, addressId: number, qoId:number): Observable<SJobAndBillingDetails> {
        return this._http.get(API.APPROVALQUEUE + '/GetJobAndBillingDetaisls/' + companyId + "/" + wojobid + "/" + workOrderId + "/" + addressId + "/" +qoId).pipe(
            map(this.extractData));
    }
    getPartRequestwojob(CompanyId: number, WoJobId: number[]): Observable<PartRequest[]> {
        debugger;
        return this._http.post(API.PART + '/GetPartRequestWojob/' + CompanyId, WoJobId).pipe(map(res => res.json()));
    }
    /**Get Notes Details - Service Notes,Technician Remarks,Approver Remarks,Invoice Notes  */
    GetNotesDetails(CompanyId: number, WoJobId: number, LoginId: number, TechTimeZoneId: number, CustomerId: number, woId: number): Observable<ServiceNotesAndTechNotes> {
        return this._http.get(API.WORKORDER + '/GetSpecInstrServNote' + '?CompanyId=' + CompanyId + '&Wojobid=' + WoJobId + '&loginId=' + LoginId + '&TechTimeZoneId=' + TechTimeZoneId + '&CustomerId=' + CustomerId + '&woId=' + woId).pipe(
            map(this.extractData));
    }

    /**Noted Add,Edit,Delete */
    addNewNotes(specialService: NotesModel): Observable<FPResponse> {
        return this._http.post(API.WORKORDER + '/InsertNotes/', specialService).pipe(
            map(this.extractData));
    }

    updateNotes(specialService: NotesModel): Observable<FPResponse> {
        return this._http.put(API.WORKORDER + '/UpdateNotes/', specialService).pipe(
            map(this.extractData));
    }

    deleteNotes(companyId: number, noteId: number): Observable<FPResponse> {
        return this._http.delete(API.WORKORDER + '/DeleteWojobServiceNotes' + '?CompanyId=' + companyId + '&NotesID=' + noteId).pipe(
            map(this.extractData));
    }

    UpdatePrintonInvoice(model: ApprovalJobModel): Observable<FPResponse> {
        return this._http.post(API.APPROVALQUEUE + "/UpdatePrintonInvoice", model).pipe(
            map(this.extractData));
    }

    /*************************** End Summary View **********************************/

    /*************************** Work Request & Pricing Panel **********************************/

    /**pricing details */

    getPricingDetails(companyId: number, woJobId: number): Observable<Pricing> {
        return this._http.get(API.APPROVALQUEUE + "/GetApprovalQueuePriceDetails" + "?CompanyId=" + companyId + "&woJobId=" + woJobId).pipe(
            map(this.extractData));
    }

    deletePricing(companyId: number, WoPriceId: number): Observable<FPResponse> {
        return this._http.delete(API.WORKORDER + '/DeleteWoJobPrice' + '?CompanyId=' + companyId + '&WoPriceId=' + WoPriceId).pipe(
            map(this.extractData));
    }
    deletePartPricing(companyId: number, WoPartPriceId: number): Observable<FPResponse> {

        return this._http.delete(API.PART + '/DeleteWoPartPrice' + '?CompanyId=' + companyId + '&WoPartPriceId=' + WoPartPriceId).pipe(
            map(this.extractData));
    }
    getPriceDiscountTypes(companyId: number): Observable<ConfigValues[]> {
        return this._http.get(API.CONFIGMASTER + "/GetConfigValueAll" + "?CompanyID=" + companyId).pipe(
            map(this.extractData));
    }

    getPricingJobDetails(companyId: number, woJobId: number): Observable<WorkRequestSaveModel[]> {
        return this._http.get(API.WORKORDER + '/GetWOJobDetails' + '?CompanyId=' + companyId + '&JobId=' + woJobId).pipe(
            map(this.extractData));
    }

    savePricingDetails(payment: PricingFormModel): Observable<FPResponse> {

        return this._http.post(API.WORKORDER + '/InsertWoJobPrice/', payment).pipe(
            map(this.extractData));
    }
    updatepartPricingDetails(partprice: PartPricing): Observable<FPResponse> {

        return this._http.put(API.PART + '/UpdateWoPartPrice/', partprice).pipe(
            map(this.extractData));
    }
    updatePricingDetails(payment: PricingFormModel): Observable<FPResponse> {

        return this._http.put(API.WORKORDER + '/UpdateWoJobPrice/', payment).pipe(
            map(this.extractData));
    }

    /**End pricing details */

    /**Work Request Details */

    getJobDetails(companyId: number, woJobId: number): Observable<WorkRequestSaveModel[]> {
        return this._http.get(API.WORKORDER + '/GetWOJobDetails' + '?CompanyId=' + companyId + '&JobId=' + woJobId).pipe(
            map(this.extractData));
    }

    getWorkTypes(companyId: number, woCategoryId: number): Observable<WorkTypeDd[]> {
        return this._http.get(API.WORKORDERMAS + '/GetAllWorkType' + '?CompanyId=' + companyId + '&WoCategoryId=' + woCategoryId).pipe(
            map(this.extractData));
    }

    getAllWorkTask(companyId: number, workTypeId: number): Observable<WorkRequestDd[]> {
        return this._http.get(API.WORKORDERMAS + '/GetAllWorkTask' + '?CompanyId=' + companyId + '&WorkTypeId=' + workTypeId).pipe(
            map(this.extractData));
    }

    insertJobDetails(jobTaskDetails: WorkRequestCFModel): Observable<FPResponse> {
        return this._http.post(API.APPROVALQUEUE + '/InsertWoJobDetails/', jobTaskDetails).pipe(
            map(this.extractData));
    }

    updateJobDetails(jobTaskDetails: WorkRequestCFModel): Observable<FPResponse> {
        return this._http.put(API.APPROVALQUEUE + '/UpdateWoJobDetailsVendorCost/', jobTaskDetails).pipe(
            map(this.extractData));
    }

    deleteJobDetails(woJobId: number, woJobDetailsId: number, companyId: number, loginId: number): Observable<FPResponse> {
        return this._http.delete(API.APPROVALQUEUE + '/DeleteJobDetailsPricingAndCost/' + '?woJobId=' + woJobId + '&WoJobDetailsId=' +
            woJobDetailsId + '&CompanyId=' + companyId + '&LastChangedBy=' + loginId).pipe(
                map(this.extractData));
    }

    /**End Work Request */

    /**Vendor Cost */

    GetJobVendorcostDetails(companyId: number, wojobId: number): Observable<JobvendorCost> {
        return this._http.get(API.APPROVALQUEUE + "/GetJobVendorcostDetails/" + companyId + "/" + wojobId).pipe(
            map(this.extractData));
    }

    updateVendorCost(vendorCostModel: WoJobvendorCost): Observable<FPResponse> {
        return this._http.put(API.APPROVALQUEUE + '/UpdateVendorCost/', vendorCostModel).pipe(
            map(this.extractData));
    }

    getVendorPaymentHistoryDetails(companyId: number, wojobId: number, timeZoneDesc: string): Observable<VendorPaymentHistory[]> {
        return this._http.get(API.APPROVALQUEUE + "/GetVendorPaymentAdjustmentHistory/" + companyId + "/" + wojobId
            + "/" + timeZoneDesc).pipe(
                map(this.extractData));
    }

    /**End Vendor Cost */

    /*************************** End Work Request & Pricing Panel **********************************/

    /*************************** Payment Details **********************************/
    getPaymentDetails(companyId: number, woJobId: number, TechTimeZoneID: number): Observable<PaymentDetail> {
        return this._http.get(API.WORKORDER + "/GetWoJobPayment" + "?CompanyId=" + companyId + "&Wojobid=" + woJobId + "&TechTimeZoneID=" + TechTimeZoneID).pipe(
            map(this.extractData));
    }

    UpdatePaymentDetails(payment: PaymentDetail): Observable<FPResponse> {
        return this._http.put(API.WORKORDER + '/UpdateWoJobPayment/', payment).pipe(
            map(this.extractData));
    }

    insertPaymentDetails(payment: PaymentDetail): Observable<FPResponse> {
        return this._http.post(API.WORKORDER + '/InsertWoJobPayment/', payment).pipe(
            map(this.extractData));
    }
    /*************************** End Payment Details **********************************/

    // ************************** Equipment Details *************************************/

    getEquipmentDetails(companyId: number, woJobId: number): Observable<EquipmentListModel[]> {
        return this._http.get(API.WORKORDER + '/GetEquipment' + '?CompanyId=' + companyId + '&JobId=' + woJobId).pipe(
            map(this.extractData));
    }

    insertEquipment(equipment: EquipmentCFModel): Observable<FPResponse> {
        return this._http.post(API.WORKORDER + '/SaveEquipmentcf/', equipment).pipe(
            map(this.extractData));
    }

    updateEquipment(equipment: EquipmentCFModel): Observable<FPResponse> {
        return this._http.put(API.WORKORDER + '/UpdateEquipmentcf/', equipment).pipe(
            map(this.extractData));
    }

    deleteEquipment(companyId: number, woJobId: number, woEquipmentId): Observable<FPResponse> {
        return this._http.delete(API.WORKORDER + '/DeletWojobEquipment' + '?CompanyId=' + companyId + '&WoJobId=' + woJobId + '&WoEquipmentId=' + woEquipmentId + '&SourceId=1').pipe(
            map(this.extractData));
    }

    getExistingEquipments(companyId: number, customerId: number, customerEquipmentId: string): Observable<ExistingEquipmentModel[]> {
        return this._http.get(API.CUSTOMER + '/GetExistingCustomerEquipments' + '?CompanyId=' + companyId + '&CustomerId=' + customerId + '&CustomerEquipmentId=' + customerEquipmentId).pipe(
            map(this.extractData));
    }
    getExistingEquipmentDetails(companyId: number, customerId: number, customerEquipmentId: string, WorkOrderId:number, WoJobId:number): Observable<ExistingEquipmentModel[]> {
        return this._http.get(API.CUSTOMER + '/GetExistingCustomerEquipmentDetail' + '?CompanyId=' + companyId + '&CustomerId=' + customerId + '&CustomerEquipmentId=' + customerEquipmentId+
        '&WorkOrderId='+WorkOrderId+'&WoJobId='+WoJobId).pipe(
            map(this.extractData));
    }
    UpdateExistEquipment(equipment: EquipmentEntity[]): Observable<FPResponse> {
        return this._http.post(API.WORKORDER + '/SaveExistEquipment/', equipment).pipe(
            map(this.extractData));
    }

    /************************** End Equipment Details *********************************/

    /**Attachement */

    getAttachementDetails(companyId: number, filterBy: number, woJobId: number): Observable<AttachmentModel[]> {
        return this._http.get(API.WORKORDER + '/GetManageWoAllAttachement' + '?CompanyId=' + companyId + '&FilterBy=' + filterBy + '&WoJobId=' + woJobId).pipe(
            map(this.extractData));
    }
    getJobAttachementsImage(companyId: number, JobId: number): Observable<AttachmentModel[]> {
        return this._http.get(API.WORKORDER + '/GetJobAttachementDetails' + '?CompanyId=' + companyId + '&JobId=' + JobId).pipe(
            map(this.extractData));
    }
    getSystemSettings(companyId: number, settingsId: number[]): Observable<SystemSettings[]> {
        return this._http.post(API.WORKORDER + '/GetSystemSettings', { CompanyId: companyId, SettingsId: settingsId }).pipe(
            map(this.extractData));
    }

    getPhotoDocumentDetails(companyId: number, configMasterId: number): Observable<ConfigValues[]> {
        return this._http.get(API.CONFIGMASTER + '/GetAll' + '?CompanyID=' + companyId + '&ConfigID=' + configMasterId).pipe(
            map(this.extractData));
    }

    saveAttachement(model: AttachmentModel[]) {
        return this._http.post(API.WORKORDER + '/ManageWoSaveAttachment/', model).pipe(
            map(this.extractData));
    }

    deleteAttachement(companyId: number, attachementId: number): Observable<FPResponse> {
        return this._http.delete(API.WORKORDER + '/DeleteAttachment' + '?CompanyId=' + companyId + '&WoAttachmentId=' + attachementId + '&SourceId=1').pipe(
            map(this.extractData));
    }
    /**End Attachement */

    /**Checklist */

    getCheckList(companyId: number, woJobId: number): Observable<ChecklistModel[]> {
        return this._http.get(API.WORKORDER + "/GetWOJobChecklist" + "?CompanyId=" + companyId + "&JobId=" + woJobId).pipe(
            map(this.extractData));
    }

    getDynamicCheckListQuestionAnswers(companyId: number, WoJobChecklistId: number): Observable<DynamicModel> {
        return this._http.get(API.WORKORDER + "/GetDynamicCheckListQuestionAnswers" + "?CompanyId=" + companyId + "&WoJobChecklistId=" + WoJobChecklistId).pipe(
            map(this.extractData));
    }

    getDynamicCheckList(companyId: number, WoJobChecklistId: number, ChklistMastId: number, Wojobid: number): Observable<DynamicCheckListDetails[]> {
        return this._http.get(API.WORKORDER + "/GetDynamicCheckListDetails1" + "?CompanyId=" + companyId + "&WoJobChecklistId=" +
            WoJobChecklistId + "&ChklistMastId=" + ChklistMastId + "&Wojobid=" + Wojobid).pipe(
                map(this.extractData));
    }

    saveDynamicCheckList(payment: DynamicSaveModel[]): Observable<FPResponse> {
        return this._http.post(API.WORKORDER + '/SaveDynamicCheckListDetails/', payment).pipe(
            map(this.extractData));
    }

    getCheckListName(companyId: number, woJobId: number, taskId: number[]): Observable<ChecklistModel[]> {
        return this._http.post(API.WORKORDER + "/GetWOJobChecklistDropDown" + "?CompanyId=" + companyId + "&JobId=" + woJobId, taskId).pipe(
            map(this.extractData));
    }

    saveCheckList(checkListModel: ChecklistModel, companyId: number): Observable<FPResponse> {
        return this._http.post(API.WORKORDER + "/InsertWOJobChecklistDetails" + "?CompanyId=" + companyId, checkListModel).pipe(
            map(this.extractData));
    }

    getCheckListAll(companyId: number, woJobId: number): Observable<ChecklistModel[]> {
        return this._http.get(API.WORKORDER + "/GetWOJobChecklist" + "?CompanyId=" + companyId + "&JobId=" + woJobId).pipe(
            map(this.extractData));
    }

    deleteCheckList(companyId: number, woJobId: number, chklistMastId: number, ChkMastId: number, LoginId: number): Observable<FPResponse> {

        return this._http.delete(API.WORKORDER + '/DeleteWOJobChecklistDetails' + '?CompanyId=' + companyId + '&WoJobId=' + woJobId + '&WoJobChklistId=' + chklistMastId + '&ChkMastId=' + ChkMastId + '&LoginId=' + LoginId).pipe(
            map(this.extractData));
    }

    /**End Checklist */

    /**Approve Job */

    updateJobApproval(model: ApprovalJobModel[]): Observable<FPResponse> {
        return this._http.post(API.APPROVALQUEUE + "/UpdateJobApprovalStatus", model).pipe(
            map(this.extractData));
    }

    /**End Approve Job */

    /**Revert Approval Job */

    updateRevertApproval(model: ApprovalJobModel): Observable<FPResponse> {
        return this._http.post(API.APPROVALQUEUE + "/UpdateJobReverApprovalStatus", model).pipe(
            map(this.extractData));
    }

    GetRevertApprovalHistory(companyId: number, wojobId: number, timeZoneDesc: string): Observable<RevertApprovalHistory[]> {
        return this._http.get(API.APPROVALQUEUE + "/GetRevertApprovalHistory/" + companyId + "/" + wojobId
            + "/" + timeZoneDesc).pipe(
                map(this.extractData));
    }

    getBrandList(CompanyId: number): Observable<BrandList[]> {
        return this._http.get(API.PART + '/GetBrandList/' + CompanyId).pipe(map(res => res.json()));
    }
    getModelList(CompanyId: number, brandId: number): Observable<ModelList[]> {
        return this._http.get(API.PART + '/GetModelList/' + CompanyId + '/' + brandId).pipe(map(res => res.json()));
    }

    // HttpRequestDownload(companyId: number, woAttachmentId: number): Observable<Download> {
    //     return this._http.get(API.ATTACHEMNTMENT + "ManageWoDownload?CompanyId=" + companyId + "&WoAttachmentId=" + woAttachmentId)
    //         .map(this.extractData);
    // }

    /**End Revert Approval Job */

    getCustomerTime(CusTimeZoneId: number): Observable<CustomerTimeZone> {
        return this._http.get(API.WORKORDER + '/GetCustomerTimeZone' + '?CustTimeZoneId=' + CusTimeZoneId).pipe(
            map(this.extractData));
    }

    //Get Job Complete Status added by Anvardeen Batcha 
    GetCompleteAndUnresolvedReason(CompanyId: number, IsActive: number, SortBy: string, OrderBy: string, startRecord: number, EndRecord: number): Observable<JobStatusReason> {
        return this._http.get(API.STATUSREASON + '/GetAll/' + '?CompanyId=' + CompanyId + '&IsActive=' + IsActive + '&SortBy=' + SortBy + '&OrderBy=' + OrderBy + '&startRecord=' + startRecord + '&EndRecord=' + EndRecord).pipe(
            map(this.extractData));
    }

    getWorkOrderJobStatus(companyId: number, isActive: number): Observable<any[]> {
        return this._http.get(API.WORKORDER + '/GetWorkOrderJobStatus/?CompanyId=' + companyId + '&IsActive=' + isActive + '&Ismobilestatus=' + 1).pipe(map(res => res.json()));
    }


    updateTechnicianJobStatus(technicianJobStatus: TechnicianJobStatusUpdate): Observable<FPResponse> {

        return this._http.post(API.SCHEDULING + '/UpdateTechnicianJobStatus/', technicianJobStatus).pipe(
            map(this.extractData));
    }

    getCustomeAddressAndInvoice(companyId: number, wojobId: number, workOrderId: number, customerId: number, CusTimeZoneDesc: string): Observable<any> {
        return this._http.get(API.INVOICEQUEUE + "GetCustomerAndInvoiceBillingDetails/" + companyId + "/" +
            wojobId + "/" + workOrderId + "/" + customerId + "/" + CusTimeZoneDesc).pipe(
                map(this.extractData));
    }

    updateCustomerAddressContact(entity: any): Observable<FPResponse> {
        return this._http.put(API.INVOICEQUEUE + 'UpdateCustomerAddressContact/', entity).pipe(map(this.extractData));
    }

    getJobHistoryDetails(companyId: number, workOrderId: string, loginId: number, jobId: number): Observable<any[]> {
        return this._http.get(API.WORKORDER + '/GetWorkOrderHistoryDetails' + '?CompanyId=' + companyId + '&WoNumber=' + workOrderId + '&WojobId=' + jobId + '&SearchKey=' + "" + '&loginId=' + loginId).pipe(
            map(this.extractData));
    }
    getUserTimeZone(timezoneId: number): Observable<any> {
        return this._http.get(API.WORKORDER + "/GetUserTimeZone?TimeZoneId=" + timezoneId).pipe(map(resp => resp.json()));
    }
    private extractData(res: Response) {

        let body = res.json();
        return body || {};
    }

    private handleError(error: Response | any) {

        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return observableThrowError(errMsg);
    }

    getTaxGroup(CompanyId: number, TaxTypeId: number): Observable<TaxGroup[]> {
        return this._http.get(API.TAXGROUPMASTER + "/GetTaxGroup/?CompanyId=" + CompanyId + '&TaxTypeId=' + TaxTypeId).pipe(map(res => res.json()));
    }

    getcheckListPrintData(model: PrintcheckListModel[]): Observable<PrintCheckListOutput> {
        return this._http.post(API.WORKORDER + '/getcheckListPrintData', model).pipe(map(res => res.json()));
    }

    GetCheckListLogo(CompanyId: number, FileName: string): Observable<Logo> {
        return this._http.get(API.COMPANY + "/GetCheckListLogo/?CompanyId=" + CompanyId + "&FileName=" + FileName).pipe(map(res => res.json()));
    }

    GetCheckHeaderLogo(CompanyId: number, FileName: string): Observable<Logo> {
        return this._http.get(API.COMPANY + "/GetCheckHeaderLogo/?CompanyId=" + CompanyId + "&FileName=" + FileName).pipe(map(res => res.json()));
    }

    GetCheckFootorLogo(CompanyId: number, FileName: string): Observable<Logo> {
        return this._http.get(API.COMPANY + "/GetCheckFootorLogo/?CompanyId=" + CompanyId + "&FileName=" + FileName).pipe(map(res => res.json()));
    }

    ExportExcelCheckList(model: PrintcheckListModel[]): Observable<DownloadFile> {
        return this._http.post(API.WORKORDER + "/exportExcelCheckList", model).pipe(map(res => res.json()));

    }
    getJoblist(CompanyId: number, WorkOrderId: number): Observable<any[]> {
        return this._http.get(API.WORKORDER + "/GetJobList?CompanyId=" + CompanyId + "&WorkOrderId=" + WorkOrderId).pipe(map(resp => resp.json()));
    }

    getCreatedDateCtz(CompanyId: number, WoJobId: number): Observable<string> {
        return this._http.get(API.WORKORDER + '/GetCreatedDateCtz/' + CompanyId + '/' + WoJobId).pipe(
            map(this.extractData));
    }

    GetRejectApprovalHistory(companyId: number, wojobId: number, timeZoneDesc: string): Observable<RevertApprovalHistory[]> {
        return this._http.get(API.APPROVALQUEUE + "/GetRejectApprovalHistory/" + companyId + "/" + wojobId
            + "/" + timeZoneDesc).pipe(
                map(this.extractData));
    }

    updateRejectApproval(model: Reject): Observable<FPResponse> {
        return this._http.post(API.APPROVALQUEUE + "/UpdateJobRejectApprovalStatus", model).pipe(
            map(this.extractData));
    }
    updateVendorApproveReject(model: Reject): Observable<FPResponse> {
        return this._http.post(API.APPROVALQUEUE + "/UpdateVendorRejectApprovalStatus", model).pipe(
            map(this.extractData));
    }
    GetPartStatusCountVendorApprovalQueue(Entity: PartDetail): Observable<FPResponse> {
        return this._http.post(API.PART + "/GetPartStatusCountVendorApprovalQueue", Entity).pipe(map(this.extractData));
    }
    updateVendorApprove(model: Reject): Observable<FPResponse> {
        return this._http.post(API.APPROVALQUEUE + "/UpdateVendorApprovalStatus", model).pipe(
            map(this.extractData));
    }
    getRegion(companyId: number, zoneId: number): Observable<Region[]> {
        return this._http.get(API.COMMON + '/GetRegion/' + companyId + "/" + zoneId).pipe(
            map(res => res.json()),
            catchError((error: any) => observableThrowError(error.json().error || 'Server error')));
    }
    saveOtherInfoCF(pkId: number, customFields: CustomFieldsConfiguration): Observable<FPResponse> {
        return this._http.post(API.CUSTOMFILEDS + '/Insert?PkId=' + pkId, customFields).pipe(map(res => res.json()));
    }
    getPriorities(CompanyId: number): Observable<any> {
        return this._http.get(API.WOPRIORITY + "/GetPriorities/" + CompanyId).pipe(map(res => res.json()));
    }
    GetContractType(CompanyId: number): Observable<ContractType[]> {
        return this._http.get(API.MODEL + '/GetContract/' + CompanyId).pipe(map(res => res.json()));
    }
    GetMultipleReasons(companyId: number, jobid: number, WoAppoinmentid: number): Observable<RefStatusReasonEntity[]> {
        return this._http.get(API.WORKORDER + '/GetJobStatusReasons/' + companyId + "/" + WoAppoinmentid + "/" + jobid).pipe(map(res => res.json()));
    }

    DeleteJobReasons(CompanyID: number, Jobid: number, woAppoinmentid: number, WoAppointmentStatusReasonId: number[]): Observable<FPResponse> {
        return this._http.post(API.APPROVALQUEUE + '/DeleteStatusReason' + '?CompanyID=' + CompanyID + '&woJobId=' + Jobid + '&woAppoinmentid=' + woAppoinmentid, WoAppointmentStatusReasonId).pipe(
            map(res => res.json()));
    }

    setPaymentDetail(paymentApproval) {
        debugger;
        this.payment.next(paymentApproval);
    }
    getPaymentDetail() {
        return this.payment.getValue();
    }

    DeleteAttachmentFile(model: FileDetails[]) {
        return this._http.post(API.WORKORDER + '/DeleteWOFile/', model).pipe(
            map(this.extractData));
    }

    getWorkCategory(companyId: number) {
        return this._http.get(API.WORKORDERMAS + "/GetWorkCategoryDetails" + "?CompanyId=" + companyId + "&isActive=1").pipe(map(res => res.json()));
    }
    getPunchPointStatus(companyId: number) {
        return this._http.get(API.WORKORDER + "/GetPunchPointStatus" + "?CompanyId=" + companyId + "&isActive=1").pipe(map(res => res.json()));
    }
    ApproveBulkPunch(punchDetail: PunchPointApproveRejectList): Observable<FPResponse> {
        return this._http.post(API.APPROVALQUEUE + '/InsertPunchPointApproveReject/', punchDetail).pipe(
            map(this.extractData));
    }
    PunchOrderCreation(punchDetail: PunchDetails): Observable<FPResponse> {
        return this._http.post(API.WORKORDER + '/CreatePunchworkorder/', punchDetail).pipe(
            map(this.extractData));
    }
    GetPunchPointApprovalQueueList(model: PunchPointApprovalQueue, MaxRoleGroupId: number, LoginId: number, LoginVendorId: number, sortBy: string, orderBy: string, startRecord: number,
        endRecord: number): Observable<PunchPointApprovalQueueList> {
        return this._http.post(API.APPROVALQUEUE + "/GetPunchPointApprovalQueueList/" + MaxRoleGroupId + "/" + LoginId + "/" + LoginVendorId + "/" + sortBy + "/" + orderBy + "/" + startRecord + "/" + endRecord, model).pipe(
            map(this.extractData));
    }
    RejectBulkPunch(punchDetail: PunchPointApproveRejectList): Observable<FPResponse> {
        return this._http.post(API.APPROVALQUEUE + '/UpdatePunchPointReject/', punchDetail).pipe(
            map(this.extractData));
    }
    deleteVendorCost(companyId: number, WoJobPriceId: number,wojobid?:number): Observable<FPResponse> {
        return this._http.delete(API.APPROVALQUEUE + '/DeleteWoJobVendorCost' + '?WoJobPriceId=' + WoJobPriceId + '&CompanyId=' + companyId + '&wojobid=' + wojobid).pipe(
            map(this.extractData));
    }
}